/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { fetchUpcomingReservations } from '../core/_requests'
import moment from 'moment'

const UpcomingReservations = () => {
  const [upcomingReservations, setUpcomingReservations] = useState<any[]>([])
  const token = localStorage.getItem('@auth/token')

  const getUpcomingReservations = async () => {
    try {
      const response = await fetchUpcomingReservations(token ?? '')
      if (response && response['hydra:member']) {
        setUpcomingReservations(response['hydra:member'])
      }
    } catch (error) {
      console.error('Error fetching upcoming reservations:', error)
    }
  }

  useEffect(() => {
    getUpcomingReservations()
  }, [])

  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'badge-light-success'
      case 'pending':
        return 'badge-light-warning'
      case 'cancelled':
        return 'badge-light-danger'
      default:
        return 'badge-light-info'
    }
  }

  const formatDateTime = (date: string, time: string) => {
    if (!date || !time) return 'N/A'

    const dateObj = moment.utc(date)
    const timeObj = moment.utc(time)

    return dateObj.format('DD/MM/YYYY') + ' ' + timeObj.format('HH:mm')
  }

  return (
    <div className='col-xl-4'>
      <div className='card card-xl-stretch mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold text-dark'>Upcoming Bookings</span>
            <span className='text-muted mt-2 fw-semibold fs-7'>Next scheduled bookings</span>
          </h3>
        </div>

        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-150px'>User</th>
                  <th className='min-w-120px'>Date & Time</th>
                  <th className='min-w-100px'>Area</th>
                  <th className='min-w-100px'>Status</th>
                </tr>
              </thead>
              <tbody>
                {upcomingReservations.length > 0 ? (
                  upcomingReservations.map((booking, index) => (
                    <tr key={index}>
                      <td>
                        <span className='text-dark fw-bold fs-6'>
                          {booking.user?.fullname || 'Unknown User'}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {formatDateTime(booking.date, booking.startTime)}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-semibold fs-7'>
                          {booking.area?.title || (booking.trainer ? 'With Trainer' : 'N/A')}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${getStatusClass(booking.status || '')}`}>
                          {booking.status || 'Unknown'}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className='text-center'>
                      <span className='text-muted fw-semibold fs-7'>No upcoming reservations</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpcomingReservations
